import React from 'react';
import {
  IResourceComponentsProps,
  useDelete,
  useNavigation,
} from '@pankod/refine-core';
import {
  Box,
  DataGrid,
  useDataGrid,
  GridColumns,
  GridActionsCellItem,
  List,
  Stack,
} from '@pankod/refine-mui';
import { Edit, Close } from '@mui/icons-material';
import { IBackgrounds } from 'interfaces';

export const BackgroundList: React.FC<IResourceComponentsProps> = () => {
  const { edit } = useNavigation();
  const { mutate: mutateDelete } = useDelete();
  const { dataGridProps } = useDataGrid<IBackgrounds>({
    initialPageSize: 5,
  });

  const columns = React.useMemo<GridColumns<IBackgrounds>>(
    () => [
      {
        field: 'thumb',
        headerName: 'Thumb',
        renderCell: function render({ row }) {
          return (
            <Stack alignItems="center" direction="column" spacing={2}>
              <Box
                component="img"
                sx={{
                  height: 40,
                  width: 60,
                }}
                alt="The house from the offer."
                src={row.thumb}
              />
            </Stack>
          );
        },
        width: 80,
        disableReorder: true,
        sortable: false,
      },
      {
        field: 'name',
        headerName: 'Name',
        flex: 1,
        minWidth: 100,
        disableReorder: true,
        sortable: true,
      },
      {
        field: 'updated_at',
        headerName: 'Date',
        flex: 1,
        minWidth: 100,
        disableReorder: true,
        sortable: true,
      },
      {
        field: 'actions',
        headerName: '#',
        type: 'actions',
        width: 40,
        getActions: function render({ row }) {
          return [
            <GridActionsCellItem
              key={1}
              label="Edit"
              icon={<Edit color="success" />}
              onClick={() => edit('Backgrounds', row.id)}
              showInMenu
            />,
            <GridActionsCellItem
              key={2}
              label="Delete"
              icon={<Close color="error" />}
              onClick={() => {
                mutateDelete({
                  resource: 'Backgrounds',
                  id: row.id,
                  mutationMode: 'undoable',
                });
              }}
              showInMenu
            />,
          ];
        },
      },
    ],
    []
  );

  return (
    <List
      title="Backgrounds"
      createButtonProps={{
        children: <> Create New Background </>,
      }}
      canCreate
      cardProps={{ sx: { paddingX: { xs: 0, md: 0 } } }}
    >
      <DataGrid
        {...dataGridProps}
        columns={columns}
        autoHeight
        disableColumnFilter={true}
        disableColumnSelector={true}
        rowsPerPageOptions={[5, 10, 15, 20]}
        density="comfortable"
        sx={{
          '& .MuiDataGrid-cell:hover': {
            cursor: 'pointer',
          },
        }}
        onRowClick={(row) => {
          edit('Backgrounds', row.id);
        }}
      />
    </List>
  );
};
